import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import axios from 'axios';

const API = 'https://app.b3rastreamento.com.br/api';

const MODELOS = [
  { modelo: 'TK103', fabricante: 'Coban', protocolo: 'GT06' },
  { modelo: 'TK303', fabricante: 'Accurate', protocolo: 'GT06' },
  { modelo: 'TK311', fabricante: 'Accurate', protocolo: 'GT06' },
  { modelo: 'Goome EV02', fabricante: 'Goome', protocolo: 'EV02' },
  { modelo: 'Goome GM06N', fabricante: 'Goome', protocolo: 'GT06' },
  { modelo: 'J16', fabricante: 'Jointech', protocolo: 'JT808' },
  { modelo: 'MXT 140', fabricante: 'Maxtrack', protocolo: 'Maxtrack' },
  { modelo: 'MXT 145', fabricante: 'Maxtrack', protocolo: 'Maxtrack' },
  { modelo: 'MXT 150', fabricante: 'Maxtrack', protocolo: 'Maxtrack' },
  { modelo: 'OneBlock', fabricante: 'OneBlock', protocolo: 'OneTag' },
  { modelo: 'OneTag', fabricante: 'OneBlock', protocolo: 'OneTag' },
  { modelo: 'GV50', fabricante: 'Queclink', protocolo: 'GT06' },
  { modelo: 'GV300', fabricante: 'Queclink', protocolo: 'GT06' },
  { modelo: 'GV310', fabricante: 'Queclink', protocolo: 'GT06' },
  { modelo: 'GV500', fabricante: 'Queclink', protocolo: 'GT06' },
  { modelo: 'ST310U', fabricante: 'Suntech', protocolo: 'ST' },
  { modelo: 'ST340', fabricante: 'Suntech', protocolo: 'ST' },
  { modelo: 'ST600R', fabricante: 'Suntech', protocolo: 'ST' },
  { modelo: 'ST4315', fabricante: 'Suntech', protocolo: 'ST' },
  { modelo: 'ST8310U', fabricante: 'Suntech', protocolo: 'ST' },
  { modelo: 'ST8310UM', fabricante: 'Suntech', protocolo: 'ST' },
  { modelo: 'ST100', fabricante: 'Sunteck', protocolo: 'GT06' },
  { modelo: 'ST200', fabricante: 'Sunteck', protocolo: 'GT06' },
  { modelo: 'ST300', fabricante: 'Sunteck', protocolo: 'GT06' },
  { modelo: 'ST400', fabricante: 'Sunteck', protocolo: 'GT06' },
];

const rotuloStatusEquip = { estoque: 'Em estoque', instalado: 'Instalado', defeito: 'Com defeito', extraviado: 'Extraviado' };

function exportarEquipamentosPDF(lista, tituloFiltro) {
  const NL = String.fromCharCode(10);
  const linhasHtml = lista.map(e => [
    '<tr>',
    '<td>' + (e.serial || '-') + '</td>',
    '<td>' + (e.modelo || '-') + '</td>',
    '<td>' + (e.fabricante || '-') + '</td>',
    '<td>' + (e.protocolo || '-') + '</td>',
    '<td>' + (e.veiculo_placa || '-') + '</td>',
    '<td>' + (e.cliente_nome || '-') + '</td>',
    '<td>' + (rotuloStatusEquip[e.status] || e.status || '-') + '</td>',
    '</tr>'
  ].join('')).join(NL);

  const conteudo = [
    '<html><head><meta charset="utf-8"><title>Equipamentos</title><style>',
    'body { font-family: Arial, sans-serif; font-size: 12px; color: #333; padding: 20px; }',
    'h1 { color: #1D9E75; font-size: 18px; margin-bottom: 4px; }',
    'p { color: #999; font-size: 11px; margin-bottom: 20px; }',
    'table { width: 100%; border-collapse: collapse; }',
    'th { background: #1D9E75; color: white; padding: 8px 10px; text-align: left; font-size: 11px; }',
    'td { padding: 8px 10px; border-bottom: 1px solid #eee; font-size: 11px; }',
    'tr:nth-child(even) td { background: #f9f9f9; }',
    '.footer { margin-top: 20px; text-align: center; color: #999; font-size: 10px; }',
    '</style></head><body>',
    '<h1>Equipamentos' + (tituloFiltro ? ' — ' + tituloFiltro : '') + '</h1>',
    '<p>Gerado em ' + new Date().toLocaleString('pt-BR') + ' — ' + lista.length + ' equipamento' + (lista.length !== 1 ? 's' : '') + ' — Desenvolvido por Digital Mais BR</p>',
    '<table><thead><tr><th>Serial</th><th>Modelo</th><th>Fabricante</th><th>Protocolo</th><th>Veículo</th><th>Cliente</th><th>Status</th></tr></thead>',
    '<tbody>' + linhasHtml + '</tbody></table>',
    '<div class="footer">Desenvolvido por Digital Mais BR — digitalmaisbr.com.br</div>',
    '</body></html>'
  ].join(NL);

  const janela = window.open('', '_blank');
  janela.document.write(conteudo);
  janela.document.close();
  janela.focus();
  setTimeout(() => janela.print(), 500);
}

function exportarEquipamentosCSV(lista) {
  const NL = String.fromCharCode(10);
  const BOM = String.fromCharCode(0xFEFF);
  const esc = (v) => '"' + (v || '').toString().split('"').join('""') + '"';
  const linhasTexto = [
    'Serial,Modelo,Fabricante,Protocolo,Veiculo,Cliente,Status',
    ...lista.map(e => [e.serial, e.modelo, e.fabricante, e.protocolo, e.veiculo_placa, e.cliente_nome, rotuloStatusEquip[e.status] || e.status].map(esc).join(','))
  ];
  const blob = new Blob([BOM + linhasTexto.join(NL)], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'equipamentos_' + new Date().toISOString().slice(0,10) + '.csv';
  a.click();
}

function Equipamentos() {
  const [sidebarAberta, setSidebarAberta] = useState(false);
  const [equipamentos, setEquipamentos] = useState([]);
  const [targets, setTargets] = useState([]);
  const [modalAberto, setModalAberto] = useState(false);
  const [busca, setBusca] = useState('');
  const [salvando, setSalvando] = useState(false);
  const [equipSelecionado, setEquipSelecionado] = useState(null);
  const [filtroStatus, setFiltroStatus] = useState(null);
  const [form, setForm] = useState({
    serial: '', modelo: '', fabricante: '', protocolo: '', firmware: 'Original', status: 'estoque', observacoes: ''
  });

  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => {
    carregarEquipamentos();
    carregarTargets();
  }, []);

  const carregarEquipamentos = async () => {
    try {
      const res = await axios.get(`${API}/equipamentos`, { headers });
      setEquipamentos(res.data);
    } catch (err) { console.error(err); }
  };

  const carregarTargets = async () => {
    try {
      const res = await axios.get(`${API}/targets`, { headers });
      setTargets(res.data);
    } catch (err) { console.error(err); }
  };

  const selecionarModelo = (modelo) => {
    const m = MODELOS.find(m => m.modelo === modelo);
    if (m) setForm(f => ({ ...f, modelo: m.modelo, fabricante: m.fabricante, protocolo: m.protocolo }));
    else setForm(f => ({ ...f, modelo }));
  };

  const salvar = async () => {
    if (!form.serial) return alert('Serial é obrigatório!');
    if (!form.modelo) return alert('Modelo é obrigatório!');
    setSalvando(true);
    try {
      if (equipSelecionado) {
        await axios.put(`${API}/equipamentos/${equipSelecionado.id}`, form, { headers });
      } else {
        await axios.post(`${API}/equipamentos`, form, { headers });
      }
      fecharModal();
      carregarEquipamentos();
    } catch (err) { alert('Erro ao salvar. Serial já cadastrado?'); }
    setSalvando(false);
  };

  const editar = (equip) => {
    setEquipSelecionado(equip);
    setForm({
      serial: equip.serial || '',
      modelo: equip.modelo || '',
      fabricante: equip.fabricante || '',
      protocolo: equip.protocolo || '',
      firmware: equip.firmware || 'Original',
      status: equip.status || 'estoque',
      observacoes: equip.observacoes || ''
    });
    setModalAberto(true);
  };

  const deletar = async (equip) => {
    // Verifica se tem target vinculado
    const temTarget = targets.some(t => t.equipamento_id === equip.id);
    if (temTarget) {
      alert('⚠️ Este equipamento está vinculado a um veículo (target).\n\nPara remover, siga a ordem:\n1️⃣ Remova o veículo (Targets)\n2️⃣ Remova a linha (Linhas GPRS)\n3️⃣ Depois remova o equipamento');
      return;
    }
    if (!window.confirm(`Deseja remover o equipamento ${equip.serial}?`)) return;
    try {
      await axios.delete(`${API}/equipamentos/${equip.id}`, { headers });
      carregarEquipamentos();
    } catch (err) {
      const msg = err.response?.data?.erro || 'Erro ao remover equipamento';
      alert(`⚠️ ${msg}`);
    }
  };

  const fecharModal = () => {
    setModalAberto(false);
    setEquipSelecionado(null);
    setForm({ serial: '', modelo: '', fabricante: '', protocolo: '', firmware: 'Original', status: 'estoque', observacoes: '' });
  };

  const statusCor = (status) => {
    if (status === 'estoque') return { bg: '#E6F1FB', cor: '#185FA5' };
    if (status === 'instalado') return { bg: '#E1F5EE', cor: '#0F6E56' };
    if (status === 'defeito') return { bg: '#FCEBEB', cor: '#A32D2D' };
    if (status === 'extraviado') return { bg: '#FFF3CD', cor: '#856404' };
    return { bg: '#f0f0f0', cor: '#666' };
  };

  const mudarStatusEquip = async (equip, novoStatus) => {
    try {
      await axios.put(`${API}/equipamentos/${equip.id}`, { ...equip, status: novoStatus }, { headers });
      carregarEquipamentos();
    } catch (err) { alert('Erro ao atualizar status'); }
  };

  const totalInstalados = equipamentos.filter(e => e.status === 'instalado').length;
  const totalEstoque = equipamentos.filter(e => e.status === 'estoque').length;
  const totalDefeito = equipamentos.filter(e => e.status === 'defeito').length;
  const totalExtraviado = equipamentos.filter(e => e.status === 'extraviado').length;

  const equipFiltrados = equipamentos.filter(e => {
    const buscaOk = !busca ||
      e.serial?.toLowerCase().includes(busca.toLowerCase()) ||
      e.modelo?.toLowerCase().includes(busca.toLowerCase()) ||
      e.protocolo?.toLowerCase().includes(busca.toLowerCase()) ||
      e.veiculo_placa?.toLowerCase().includes(busca.toLowerCase()) ||
      e.veiculo_nome?.toLowerCase().includes(busca.toLowerCase()) ||
      e.cliente_nome?.toLowerCase().includes(busca.toLowerCase());
    const statusOk = !filtroStatus || e.status === filtroStatus;
    return buscaOk && statusOk;
  });

  const inputStyle = { width: '100%', padding: '10px 12px', border: '1.5px solid #e0e0e0', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box', outline: 'none' };
  const labelStyle = { display: 'block', marginBottom: '4px', color: '#555', fontSize: '13px', fontWeight: '500' };
  const fabricantes = [...new Set(MODELOS.map(m => m.fabricante))].sort();

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5' }}>
      <Sidebar aberta={sidebarAberta} setAberta={setSidebarAberta} />

      <div style={{ background: '#1D9E75', padding: '0 24px', height: '60px', display: 'flex', alignItems: 'center', gap: '16px', position: 'fixed', top: 0, left: 0, right: 0, zIndex: 50, boxShadow: '0 2px 10px rgba(0,0,0,0.2)' }}>
        <button onClick={() => setSidebarAberta(!sidebarAberta)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '22px', color: 'white' }}>☰</button>
        <span style={{ color: 'white', fontWeight: '700', fontSize: '18px' }}>📟 Equipamentos</span>
        <span style={{ color: 'rgba(255,255,255,0.7)', fontSize: '14px' }}>({equipamentos.length} cadastrados)</span>
      </div>

      <div style={{ paddingTop: '80px', padding: '80px 24px 24px' }}>
        <div style={{ background: '#FFF3CD', borderRadius: '8px', padding: '12px 16px', marginBottom: '16px', fontSize: '13px', color: '#856404' }}>
          ⚠️ <strong>Ordem de remoção:</strong> Para remover um equipamento, primeiro remova o Veículo (Targets), depois a Linha GPRS e por último o Equipamento.
        </div>

        {/* Contadores — clique pra filtrar */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '16px', marginBottom: '24px' }}>
          {[
            { label: 'Total de equipamentos', valor: equipamentos.length, cor: '#1D9E75', chave: null },
            { label: '✅ Instalados', valor: totalInstalados, cor: '#22C55E', chave: 'instalado' },
            { label: '📦 Em estoque', valor: totalEstoque, cor: '#3B82F6', chave: 'estoque' },
            { label: '❌ Com defeito', valor: totalDefeito, cor: '#EF4444', chave: 'defeito' },
            { label: '🟡 Extraviados', valor: totalExtraviado, cor: '#F59E0B', chave: 'extraviado' },
          ].map(card => (
            <div key={card.label} onClick={() => setFiltroStatus(filtroStatus === card.chave ? null : card.chave)}
              style={{
                background: 'white', borderRadius: '12px', padding: '20px', cursor: 'pointer',
                boxShadow: filtroStatus === card.chave ? `0 0 0 2px ${card.cor}, 0 2px 8px rgba(0,0,0,0.06)` : '0 2px 8px rgba(0,0,0,0.06)',
                borderLeft: `4px solid ${card.cor}`, transition: 'box-shadow 0.15s'
              }}>
              <div style={{ fontSize: '28px', fontWeight: '700', color: card.cor }}>{card.valor}</div>
              <div style={{ fontSize: '13px', color: '#666', marginTop: '4px' }}>{card.label}</div>
            </div>
          ))}
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', gap: '12px', flexWrap: 'wrap' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flex: '1 1 400px' }}>
            <input placeholder="🔍 Buscar por serial, modelo, placa ou cliente..." value={busca} onChange={e => setBusca(e.target.value)} style={{ ...inputStyle, width: '400px' }} />
            {filtroStatus && (
              <span style={{ fontSize: '12px', color: '#666' }}>
                Filtrando: <strong>{rotuloStatusEquip[filtroStatus]}</strong>{' '}
                <button onClick={() => setFiltroStatus(null)} style={{ background: 'none', border: 'none', color: '#1D9E75', cursor: 'pointer', fontSize: '12px', textDecoration: 'underline' }}>limpar</button>
              </span>
            )}
          </div>
          <div style={{ display: 'flex', gap: '8px' }}>
            <button onClick={() => exportarEquipamentosPDF(equipFiltrados, filtroStatus ? rotuloStatusEquip[filtroStatus] : null)} style={{ background: '#E6F1FB', color: '#185FA5', border: 'none', borderRadius: '8px', padding: '10px 16px', cursor: 'pointer', fontSize: '13px', fontWeight: '600' }}>📄 Exportar PDF</button>
            <button onClick={() => exportarEquipamentosCSV(equipFiltrados)} style={{ background: '#E1F5EE', color: '#0F6E56', border: 'none', borderRadius: '8px', padding: '10px 16px', cursor: 'pointer', fontSize: '13px', fontWeight: '600' }}>📥 Exportar Excel</button>
            <button onClick={() => setModalAberto(true)} style={{ background: '#1D9E75', color: 'white', border: 'none', borderRadius: '8px', padding: '10px 20px', cursor: 'pointer', fontSize: '14px', fontWeight: '600' }}>+ Novo Equipamento</button>
          </div>
        </div>

        <div style={{ background: 'white', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', overflow: 'hidden' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#f8f8f8' }}>
                {['Serial', 'Modelo', 'Fabricante', 'Protocolo', 'Veículo/Cliente', 'Status', 'Ações'].map(h => (
                  <th key={h} style={{ padding: '14px 16px', textAlign: 'left', fontSize: '13px', color: '#666', fontWeight: '600', borderBottom: '1px solid #eee' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {equipFiltrados.length === 0 ? (
                <tr><td colSpan="7" style={{ padding: '48px', textAlign: 'center', color: '#999' }}>
                  <div style={{ fontSize: '48px', marginBottom: '12px' }}>📟</div>
                  <div>Nenhum equipamento cadastrado</div>
                </td></tr>
              ) : equipFiltrados.map((e, i) => {
                const sc = statusCor(e.status);
                const temTarget = targets.some(t => t.equipamento_id === e.id);
                return (
                  <tr key={i} style={{ borderBottom: '1px solid #f0f0f0' }}
                    onMouseEnter={ev => ev.currentTarget.style.background = '#f9f9f9'}
                    onMouseLeave={ev => ev.currentTarget.style.background = 'white'}>
                    <td style={{ padding: '14px 16px', fontSize: '13px', fontFamily: 'monospace', fontWeight: '600' }}>{e.serial}</td>
                    <td style={{ padding: '14px 16px', fontSize: '14px', fontWeight: '500' }}>{e.modelo}</td>
                    <td style={{ padding: '14px 16px', fontSize: '14px', color: '#666' }}>{e.fabricante}</td>
                    <td style={{ padding: '14px 16px' }}>
                      <span style={{ background: '#EEEDFE', color: '#3C3489', padding: '4px 10px', borderRadius: '20px', fontSize: '12px', fontWeight: '500' }}>{e.protocolo}</span>
                    </td>
                    <td style={{ padding: '14px 16px', fontSize: '13px', color: '#666' }}>
                      <div>{e.veiculo_placa || '—'}</div>
                      {e.cliente_nome && <div style={{ fontSize: '11px', color: '#1D9E75' }}>{e.cliente_nome}</div>}
                    </td>
                    <td style={{ padding: '14px 16px' }}>
                      <span style={{ background: sc.bg, color: sc.cor, padding: '4px 10px', borderRadius: '20px', fontSize: '12px', fontWeight: '500' }}>{rotuloStatusEquip[e.status] || e.status}</span>
                    </td>
                    <td style={{ padding: '14px 16px' }}>
                      <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                        <button onClick={() => editar(e)} style={{ background: '#E6F1FB', color: '#185FA5', border: 'none', borderRadius: '6px', padding: '6px 10px', cursor: 'pointer', fontSize: '12px', fontWeight: '500' }}>✏️</button>
                        <select value={e.status || 'estoque'} onChange={ev => mudarStatusEquip(e, ev.target.value)}
                          style={{ border: '1px solid #ddd', borderRadius: '6px', padding: '6px 8px', fontSize: '12px', background: 'white', cursor: 'pointer' }}>
                          <option value="estoque">📦 Em estoque</option>
                          <option value="instalado">✅ Instalado</option>
                          <option value="defeito">❌ Com defeito</option>
                          <option value="extraviado">🟡 Extraviado</option>
                        </select>
                        <button onClick={() => deletar(e)}
                          style={{ background: temTarget ? '#f0f0f0' : '#FCEBEB', color: temTarget ? '#999' : '#A32D2D', border: 'none', borderRadius: '6px', padding: '6px 10px', cursor: 'pointer', fontSize: '12px', fontWeight: '500' }}
                          title={temTarget ? 'Remova o veículo vinculado primeiro' : 'Remover equipamento'}>
                          🗑️
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      {modalAberto && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: 'white', borderRadius: '16px', padding: '32px', width: '560px', maxHeight: '85vh', overflowY: 'auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
              <h2 style={{ margin: 0, color: '#333' }}>{equipSelecionado ? '✏️ Editar Equipamento' : '➕ Novo Equipamento'}</h2>
              <button onClick={fecharModal} style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: '#999' }}>×</button>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
              <div style={{ gridColumn: '1/-1' }}>
                <label style={labelStyle}>Serial / IMEI *</label>
                <input style={inputStyle} value={form.serial} onChange={e => setForm({ ...form, serial: e.target.value })} placeholder="Ex: 869731057522617" />
              </div>
              <div style={{ gridColumn: '1/-1' }}>
                <label style={labelStyle}>Modelo * (protocolo preenchido automaticamente)</label>
                <select style={inputStyle} value={form.modelo} onChange={e => selecionarModelo(e.target.value)}>
                  <option value="">Selecione o modelo</option>
                  {fabricantes.map(fab => (
                    <optgroup key={fab} label={fab}>
                      {MODELOS.filter(m => m.fabricante === fab).map(m => (
                        <option key={m.modelo} value={m.modelo}>{m.modelo}</option>
                      ))}
                    </optgroup>
                  ))}
                </select>
              </div>
              <div>
                <label style={labelStyle}>Fabricante</label>
                <input style={{ ...inputStyle, background: '#f9f9f9' }} value={form.fabricante} readOnly />
              </div>
              <div>
                <label style={labelStyle}>Protocolo</label>
                <input style={{ ...inputStyle, background: '#f9f9f9', color: '#3C3489', fontWeight: '600' }} value={form.protocolo} readOnly />
              </div>
              <div>
                <label style={labelStyle}>Firmware</label>
                <input style={inputStyle} value={form.firmware} onChange={e => setForm({ ...form, firmware: e.target.value })} placeholder="Original" />
              </div>
              <div>
                <label style={labelStyle}>Status</label>
                <select style={inputStyle} value={form.status} onChange={e => setForm({ ...form, status: e.target.value })}>
                  <option value="estoque">📦 Estoque</option>
                  <option value="instalado">✅ Instalado</option>
                  <option value="defeito">❌ Defeito</option>
                  <option value="extraviado">⚠️ Extraviado</option>
                </select>
              </div>
              <div style={{ gridColumn: '1/-1' }}>
                <label style={labelStyle}>Observações</label>
                <textarea style={{ ...inputStyle, height: '80px', resize: 'vertical' }} value={form.observacoes} onChange={e => setForm({ ...form, observacoes: e.target.value })} placeholder="Observações sobre o equipamento..." />
              </div>
            </div>

            {form.protocolo && (
              <div style={{ background: '#EEEDFE', borderRadius: '8px', padding: '12px', marginTop: '16px' }}>
                <span style={{ color: '#3C3489', fontSize: '13px' }}>✅ Protocolo <strong>{form.protocolo}</strong> detectado automaticamente para o modelo <strong>{form.modelo}</strong></span>
              </div>
            )}

            <div style={{ display: 'flex', gap: '12px', marginTop: '24px', justifyContent: 'flex-end' }}>
              <button onClick={fecharModal} style={{ padding: '10px 20px', border: '1.5px solid #ddd', borderRadius: '8px', background: 'white', cursor: 'pointer', fontSize: '14px' }}>Cancelar</button>
              <button onClick={salvar} disabled={salvando} style={{ padding: '10px 24px', background: salvando ? '#ccc' : '#1D9E75', color: 'white', border: 'none', borderRadius: '8px', cursor: salvando ? 'not-allowed' : 'pointer', fontSize: '14px', fontWeight: '600' }}>
                {salvando ? 'Salvando...' : equipSelecionado ? 'Atualizar' : 'Salvar'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Equipamentos;